export default "__VITE_ASSET__19998188__"